import React, { useEffect, useState } from 'react';
import { Course, UserRole } from '../../types/lms.types';

interface AllContentViewProps {
   courses:any[];
   userRole: UserRole;
}

const mockContent = [
  {
    _id: '1',
    moduleId: 'mod-1',
    type: 'assignment',
    title: 'Assignment 1: Problem Solving',
    description: 'Solve 5 problems from Chapter 2',
    dueDate: '2025-07-10',
    status: 'Pending',
    icon: '📝',
  },
  {
    _id: '2',
    moduleId: 'mod-2',
    type: 'material',
    title: 'Lecture Notes - Thermodynamics',
    description: 'Detailed notes on thermodynamics.',
    uploadDate: '2025-06-20',
    status: 'Available',
    icon: '📄',
  },
  {
    _id: '3',
    moduleId: 'mod-1',
    type: 'quiz',
    title: 'Quiz 1: Laws of Motion',
    description: 'MCQ Quiz based on Newton’s Laws.',
    dueDate: '2025-07-05',
    status: 'Submitted',
    icon: '❓',
  },
  {
    _id: '4',
    moduleId: 'mod-1',
    type: 'announcement',
    title: 'Important Notice',
    description: 'Class test has been rescheduled.',
    date: '2025-06-15',
    status: '',
    icon: '📢',
  },
];

const Assignment: React.FC<AllContentViewProps> = ({ courses, userRole }) => {
  const [allContent, setAllContent] = useState<any[]>([]);

//   useEffect(() => {
//     const loadMockContent = () => {
//       if (selectedModule === 'all') {
//         setAllContent(mockContent);
//       } else {
//         setAllContent(mockContent.filter(item => item.moduleId === selectedModule));
//       }
//     };

//     loadMockContent();
//   }, [userRole, course.subjectId, selectedModule]);

  const getStatusBadge = (status: string, type: string) => {
    const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

    if (type === 'assignment' || type === 'quiz') {
      switch (status) {
        case 'Pending':
          return `${baseClasses} bg-yellow-100 text-yellow-800`;
        case 'Submitted':
          return `${baseClasses} bg-green-100 text-green-800`;
        case 'Available':
          return `${baseClasses} bg-blue-100 text-blue-800`;
        default:
          return `${baseClasses} bg-gray-100 text-gray-800`;
      }
    }
    return `${baseClasses} bg-gray-100 text-gray-800`;
  };

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <h2 className="text-xl font-semibold">All Content</h2>
        <div className="text-sm text-gray-500">Showing {allContent.length} items</div>
      </div>

      <div className="space-y-4">
        {allContent.map((item) => (
          <div
            key={`${item.type}-${item._id}`}
            className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 p-6 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-2xl">{item.icon}</span>
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                      {item.title}
                    </h3>
                    <span className="text-xs uppercase tracking-wider text-gray-500 font-medium">
                      {item.type}
                    </span>
                  </div>
                </div>

                <p className="text-gray-600 dark:text-gray-400 mb-3">{item.description}</p>

                <div className="flex items-center gap-4 text-sm text-gray-500">
                  {item.type === 'assignment' && <span>Due: {item.dueDate}</span>}
                  {item.type === 'quiz' && <span>Due: {item.dueDate}</span>}
                  {item.type === 'material' && <span>Uploaded: {item.uploadDate}</span>}
                  {item.type === 'announcement' && <span>Posted: {item.date}</span>}
                </div>
              </div>

              <div className="flex flex-col items-end gap-2">
                {item.status && (
                  <span className={getStatusBadge(item.status, item.type)}>{item.status}</span>
                )}

                <button className="inline-flex items-center px-3 py-1 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100">
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {allContent.length === 0 && (
        <div className="text-center py-12">
          <span className="text-6xl mb-4 block">📭</span>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No Contents Found</h3>
          <p className="text-gray-500">No contents available for the selected module.</p>
        </div>
      )}
    </div>
  );
};

export default Assignment;
